import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { styled } from '@mui/material';

export const ConfettiAnimation = styled(DotLottieReact)(({ theme }) => ({
    position: 'fixed',
    top: '10%',
    zIndex: 1500,
    width: '70%',

    [theme.breakpoints.up('xl')]: {
        width: '55%',
    },

    [theme.breakpoints.down('smallTablet')]: {
        width: '100%',
    },

    [theme.breakpoints.down('mobile')]: {
        width: '170%',
        top: '23%',
    },

    '&.left': {
        left: 0,
        transform: 'translateX(-30%)',
    },

    '&.right': {
        right: 0,
        transform: 'translateX(30%)',
    },
}));
